module.exports = __webpack_public_path__ + "static/media/auto-bg.7220047e.jpg";